<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Certificate Information Form</h5>

    <div>

      <form>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Receipt Number </label>
            <input value="{{Calibration_Device.dsc}}" disabled type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Instrument Name </label>
            <input value="{{Calibration_Device.device_name}}" disabled type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Instrument Code </label>
            <input [(ngModel)]="Calibration_Device.device_code" name="device_code" placeholder="Type here..."
              type="text" class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Instrument Serial Number </label>
            <input [(ngModel)]="Calibration_Device.device_serial" name="device_serial" placeholder="Type here..."
              type="text" class="form-control">
          </div>
        </div>

      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

          <div class="form-group col-md-6">
            <app-DataEntityLabAddress [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Lab_Address]="Calibration_Device.labAdderss"
              (outter_selected_Lab_Address)="Set_LabAddress_click($event)">

            </app-DataEntityLabAddress>
          </div>


        </div>
      </form>

      <br />
      <hr />
      <br />

      <app-DataEntityCertificateNote [inner_Calibration_Device_Id]="Calibration_Device_Id">

      </app-DataEntityCertificateNote>

      <br />
      <hr />
      <br />

      <app-AddressLetterCertificate [inner_Calibration_Detail_Id]="Calibration_Device_Id">

      </app-AddressLetterCertificate>

      <br />
      <hr />
      <br />

      <form>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Unit Nominal </label>
            <select class="custom-select" [(ngModel)]="unit_nominal" name="unit_nominal">
              <option value="">Select</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MANUFACTURE </label>
            <input [(ngModel)]="Manufacture_txt" name="Manufacture_txt" type="text" class="form-control"
              placeholder="Type here...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MODEL </label>
            <input [(ngModel)]="Model_txt" name="Model_txt" type="text" class="form-control"
              placeholder="Type here...">
          </div>

        </div>

      </form>

      <form>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Solution Temperature </label>
            <input [(ngModel)]="value1" name="value1" type="text" class="form-control"
              placeholder="Type here...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Millivolts at pH 7 </label>
            <input [(ngModel)]="value2" name="value2" type="text" class="form-control"
              placeholder="Type here...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Millivolts at pH 10 </label>
            <input [(ngModel)]="value3" name="value3" type="text" class="form-control"
              placeholder="Type here...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Millivolts at pH 4 </label>
            <input [(ngModel)]="value4" name="value4" type="text" class="form-control"
              placeholder="Type here...">
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> mV at pH = 7.00 (mV) Calculated Value</label>
            <input [(ngModel)]="mvatPh" name="mvatPh" type="text" class="form-control"
              placeholder="Type here...">
          </div>

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Response time at pH 4 to pH 7  (S) Calculated Value </label>
            <input [(ngModel)]="responseTime" name="responseTime" type="text" class="form-control"
              placeholder="Type here...">
          </div>



        </div>

      </form>


      <br />
      <hr />
      <br />


      <form [formGroup]="MainFormDataEntity">

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © before </label>
            <input formControlName="Temperature_Air_before" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Temperature_Air_before().valid && get_Form_Temperature_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Enter the air temperature before calibration (°C).</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © after </label>
            <input formControlName="Temperature_Air_after" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Temperature_Air_after().valid && get_Form_Temperature_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Enter the air temperature after calibration (°C).</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) before </label>
            <input formControlName="Humidity_Air_before" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Humidity_Air_before().valid && get_Form_Humidity_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Enter the relative humidity before calibration (%RH).</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) after </label>
            <input formControlName="Humidity_Air_after" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Humidity_Air_after().valid && get_Form_Humidity_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Enter the relative humidity after calibration (%RH).</small>
          </div>


        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) before </label>
            <input formControlName="Pressure_before" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Pressure_before().valid && get_Form_Pressure_before().touched"
              class="form-text text-muted MyErrorRedColor">Enter the ambient pressure before calibration (hPa).</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) after </label>
            <input formControlName="Pressure_after" type="number" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_Pressure_after().valid && get_Form_Pressure_after().touched"
              class="form-text text-muted MyErrorRedColor">Enter the ambient pressure after calibration (hPa).</small>
          </div>


        </div>


      </form>

      <br />
      <hr />
      <br />



    </div>


    <div>

      <h5 class="card-title">Range / Resolution</h5>


      <form [formGroup]="ResolutionFormDataEntity" (submit)="Add_Resolution()">
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Min Rage </label>
            <input formControlName="range_min" type="text" class="form-control EnglishClm"
              placeholder="Type here...">
          </div>

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Max Rage </label>
            <input formControlName="range_max" type="text" class="form-control EnglishClm"
              placeholder="Type here...">
          </div>

        </div>
        <button type="submit" [disabled]="!ResolutionFormDataEntity.valid" class="btn btn-success"
          style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Range / Resolution </button>
      </form>

      <div class="table-responsive" *ngIf="DataList_Resolution.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #39411b; color: white;">
            <tr>
              <th>#</th>
              <th>Min Range</th>
              <th>Max Range</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Resolution">
              <td>{{DataList_Resolution.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.range_min}}</td>
              <td class="EnglishClm">{{item.range_max}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a style="cursor: pointer;" class="dropdown-item"
                        (click)="Delete_Resolution(DataList_Resolution.indexOf(item))"><i class="fa fa-remove"></i>
                        Delete
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>


        </table>
      </div>

    </div>

    <div>

      <br />
      <hr />
      <br />
      <button *ngIf="InProccessing" type="button" class="btn btn-info" style="margin-right: 5px;"> This feature is under development.
        The certificate is being generated. Please wait... <i class="fa fa-spin fa-spinner"></i> </button>

      <button *ngIf="!InProccessing && !CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-success" style="margin-right: 5px;"><i
          class="fa  fa-plus-circle"></i> Save Certificate Information </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-info" style="margin-right: 5px;"><i
          class="fa  fa-edit"></i>
        Edit
        Certificate Information </button>

      <a target="_blank" *ngIf="!InProccessing && CertificateCode && CertificateUrlPdf" href="{{CertificateUrlPdf}}"
        style="margin-right: 5px;" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> Calibration Certificate File </a>

      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button" style="margin-right: 5px;"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>

    </div>

  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Certificate Code </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Calibration form certificate code <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCodeSerialDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Warning </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CodeSerial.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <h6> {{modalRef_CodeSerial_Title}} </h6>

  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="onSubmit_Code(templateCode,templateCodeSerialDevice,1)">Yes,
      Approved</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CodeSerial.hide()">No</button>
  </div>
</ng-template>